
import React, { useEffect, useRef, useState } from "react";
// import "./add-details.css";
import { connect } from "react-redux";
import MaterialFlavors from "material-table";
import Spinner from "react-bootstrap/Spinner";
import { baseURL, headers } from "../../../../../global/api";
import { Row, Col, Form, Container, Button, FormGroup } from "react-bootstrap";
import moment from "moment";
import { setHeading } from "../../../accounts/account.actions";
import MaterialTable from "material-table";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import {
  deleteExternalIssuance,
  deleteExternalIssuanceProduct,
  getExternalIssuance,
  getExternalIssuanceByDate,
  pdfExternalIssuance,
  updateExternalIssuanceProduct,
  // updateExternalIssuance,
} from "./IssuanceByVendor.action";
import { isEmpty } from "lodash";

const ViewIssuanceByVendorWithDate = (props) => {
  const [startDate, setStartDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const tableRef = useRef();
  function updateTableQuery () {
    tableRef.current.onQueryChange()
  };
  function uploadOrder() {
    props.getExternalIssuanceByDate(
      {
        startDate: startDate,
        endDate: endDate
      },
    );

    setStartDate(moment(new Date()).format("YYYY-MM-DD"))
    setEndDate(moment(new Date()).format("YYYY-MM-DD"))
  }
  useEffect(() => {
    props.setHeading("External Issuance List");
  }, []);
  return (
    <>
      {props.isFetchingExternalIssuanceList ? (
        <div className="loader-div">
          <Spinner
            variant="primary"
            animation="grow"
            size="xl"
            role="status"
            aria-hidden="true"
          />
        </div>
      ) : (
        <Container fluid>
                 <Row>
            <Col >
              <FormGroup>
                <Form.Label>
                  <b>Start Date :</b>
                </Form.Label>
                <Form.Control
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                ></Form.Control>
              </FormGroup>
            </Col>
            <Col >
              <FormGroup>
                <Form.Label>
                  <b>End Date :</b>
                </Form.Label>
                <Form.Control
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                ></Form.Control>
              </FormGroup>
            </Col>

          </Row>
          <div className="sendDiv" style={{marginTop:10}}>
            {isEmpty(startDate)||isEmpty(endDate) ? (
                <Button disabled>Get External Issuance</Button>
            ) : (
                <Button onClick={uploadOrder}>Get External Issuance</Button>
               
            )}
          </div>
          <div className="main" hidden={props.tableShow == false ? true : false}>
            <MaterialFlavors
              title="External Issuance Details"
              columns={[
                // { title: 'Flavors Id', field: 'table_id', editable: 'never' },
                { title: "External Issuance Date", field: "date" },
                { title: "Issued By", field: "issuedBy" },
                {
                  title: "External Issuance Description",
                  field: "issuanceDescription",
                },
              ]}
              data={props.externalIssuanceListWithDate}
              // data={(query) =>
              //   new Promise((resolve, reject) => {
              //     let url = `${baseURL}/externalIssuance?`;
              //     url += "limit=" + query.pageSize;
              //     url += "&page=" + query.page;
              //     url += "&search=" + query.search;
              //     fetch(url, {
              //       method: "GET",
              //       headers: headers,
              //     })
              //       .then((response) => response.json())
              //       .then((result) => {
              //         resolve({
              //           data: result.data,
              //           page: result.page,
              //           totalCount: result.total_results,
              //         });
              //       });
              //   })
              // }
              detailPanel={(rowData) => {
                return (
                  <MaterialTable
                    //columns={state.columnsData}
                    columns={[
                      { title: "Product Name ", field: "productLabel" },
                      {
                        title: "Product Price",
                        field: "productSellingPrice",
                      },
                      {
                        title: "Add Quantity",
                        field: "quantity",
                      },
                      {
                        title: "Total Price",
                        field: "totalSaleValue",
                      },
                    ]}
                    data={rowData.data}
                    // data={(query) =>
                    //     new Promise((resolve, reject) => {
                    //         let url = `${baseURL}/receiving?`;
                    //         url += "limit=" + query.pageSize;
                    //         url += "&page=" + (query.page);
                    //         url += "&search=" + query.search;
                    //         fetch(url, {
                    //             method: 'GET',
                    //             headers: headers,
                    //         })
                    //             .then((response) => response.json())

                    //             .then((result) => {
                    //                 let a=-1;
                    //                 resolve({

                    //                     data: result.data[a+1].receivingData,
                    //                     page: result.page,
                    //                     totalCount: result.total_results,
                    //                 });
                    //             });

                    //     })
                    // }
                    options={{
                      actionsColumnIndex: -1,
                      toolbar: false,
                      exportButton: true,
                      sorting: true,
                      paging: false,
                      pageSize: 200, // make initial page size
                      emptyRowsWhenPaging: false, // To avoid of having empty rows
                      pageSizeOptions: [50, 100, 150, 200], // rows selection options
                      headerStyle: {
                        position: "sticky",
                        top: 0,
                        color: "#00BBBB",
                        fontWeight: "550",
                        onRowAdd: "none",
                      },
                    }}
                    editable={{
                      onRowUpdate: (newData, oldData) =>
                        new Promise((resolve) => {
                          setTimeout(() => {
                            resolve();
                            {
                              props.updateExternalIssuanceProduct(newData, oldData,rowData,updateTableQuery);
                            }
                          }, 600);
                        }),
                      onRowDelete: (oldData) =>
                        new Promise((resolve) => {
                          setTimeout(() => {
                            resolve();
                            props.deleteExternalIssuanceProduct(oldData,rowData,updateTableQuery);
                          }, 600);
                        }),
                    }}
                  />
                );
              }}
              options={{
                actionsColumnIndex: -1,
                // filtering: true,
                exportButton: true,
                exportAllData: true,
                paging: true,
                pageSize: 50, // make initial page flavors
                emptyRowsWhenPaging: false, // To avoid of having empty rows
                pageSizeOptions: [30, 50, 100, 150, 200], // rows selection options
                headerStyle: {
                  position: "sticky",
                  top: 0,
                  color: "#00BBBB",
                  fontWeight: "550",
                  onRowAdd: "none",
                },
              }}
              actions={[
                {
                  icon: () => <PictureAsPdfIcon />,
                  tooltip: "Generate PDF",
                  onClick: (event, rowData) => {
                    props.pdfExternalIssuance(rowData);
                  },
                },
              ]}
              // onRowClick={(event, rowData, togglePanel) => togglePanel()}
              editable={{
                // onRowUpdate: (newData, oldData) =>
                //   new Promise((resolve) => {
                //     setTimeout(() => {
                //       resolve();
                //       {
                //         props.updateExternalIssuance(newData, oldData);
                //       }
                //     }, 600);
                //   }),
                onRowDelete: (oldData) =>
                  new Promise((resolve) => {
                    setTimeout(() => {
                      resolve();
                      props.deleteExternalIssuance(oldData._id);
                    }, 600);
                  }),
              }}
            />
          </div>
        </Container>
      )}
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    getExternalIssuanceByDate: (data) => dispatch(getExternalIssuanceByDate(data)),
    deleteExternalIssuance: (id) => dispatch(deleteExternalIssuance(id)),
    pdfExternalIssuance: (data) => dispatch(pdfExternalIssuance(data)),
    // updateExternalIssuance: (newData, oldData) =>
    //   dispatch(updateExternalIssuance(newData, oldData)),
    setHeading: (data) => dispatch(setHeading(data)),
    deleteExternalIssuanceProduct: (data,rowdata,updateTableQuery) => dispatch(deleteExternalIssuanceProduct(data,rowdata,updateTableQuery)),
    // pdfExternalIssuance: (data) => dispatch(pdfExternalIssuance(data)),
    updateExternalIssuanceProduct: (newData, oldData,rowData,updateTableQuery) =>
      dispatch(updateExternalIssuanceProduct(newData, oldData,rowData,updateTableQuery)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  externalIssuanceListWithDate:
    state.ExternalIssuanceReducer.externalIssuanceListWithDate,
  isFetchingExternalIssuanceListWithDate:
    state.ExternalIssuanceReducer.isFetchingExternalIssuanceListWithDate,
    tableShow:state.ExternalIssuanceReducer.tableShow
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewIssuanceByVendorWithDate);
